import { createSlice } from '@reduxjs/toolkit';

/**
 * Leave Legacy — UI state (active tab + approvals badge count).
 * Server data is fetched on demand via views/admin/leave/api.js.
 */
const leaveSlice = createSlice({
	name: 'leaveLegacy',
	initialState: {
		activeTab: 0,
		approvalsCount: 0,
	},
	reducers: {
		setLeaveTab: (state, action) => {
			state.activeTab = action.payload;
		},
		setApprovalsCount: (state, action) => {
			state.approvalsCount = action.payload;
		},
	},
});

export const { setLeaveTab, setApprovalsCount } = leaveSlice.actions;
export default leaveSlice.reducer;
